// extracted by mini-css-extract-plugin
export var container = "structured-text-content-container-module--container--dc4bb";
export var structuredText = "structured-text-content-container-module--structuredText--e4f87";